module.exports = __webpack_public_path__ + "static/media/Plata.03530ec3.webp";